export const uploadcarePublicKey = import.meta.env.VITE_UPLOADCAREPUBLICKEY

export const cardApiBaseUrl = import.meta.env.VITE_CARDAPIBASEURL

export const cardApiSubKey = import.meta.env.VITE_CARD_API_SUB_KEY

export const EmptyGuid = "00000000-0000-0000-0000-000000000000"
